export const mapArray = (arr: Array<any>, key: string): Record<string, any> => {
  if (Array.isArray(arr)) {
    return arr.reduce((acc: Record<string, any>, val: any) => ({ ...acc, [val[key]]: val }), {});
  }

  return {};
};
